var map = {
	"./chatBarController.js": 5825,
	"./chatController.js": 2586,
	"./detailsController.js": 7097,
	"./dialogController.js": 7850,
	"./dialogHeaderController.js": 5002,
	"./dialogMessagesController.js": 9205,
	"./dialogsController.js": 7542,
	"./friendsController.js": 6664,
	"./linkCardController.js": 1206,
	"./linkCardMessagesController.js": 9596,
	"./playTogetherController.js": 2335,
	"./userConversationInfoController.js": 9976
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9084;